<template>
<mm-tab-title v-model="tab" :titles="titles">
    <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
    <div>
        <el-form ref="form" :model="result" size="small" label-width="200px">
        
            <div v-show="tab===1">
                <el-form-item label="User Name" prop="user_name"  required>
                    <el-input v-model="result.user_name" :readonly="edit" />
                </el-form-item>
                <el-form-item label="Status" prop="status" required>
                    <el-radio-group v-model="result.status">
                        <el-radio label='active'>active</el-radio>
                        <el-radio label='pending'>pending</el-radio>
                        <el-radio label='paused'>paused</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Group" v-show="is_show_auth">
                    <mm-group v-model="result.group_id"></mm-group>
                </el-form-item>
                <el-form-item label="Email" prop="email" type="email"  required>
                    <el-input v-model="result.email" :readonly="emailInputRO" @blur="setRO()" @focus="rmRO()"/>
                </el-form-item>
                <el-form-item label="Login Password" prop="login_passwd" v-show="!edit">
                    <el-input v-model="result.login_passwd" type="password"/>
                </el-form-item>
                <el-form-item label="Phone" prop="phone">
                    <el-input v-model="result.phone"/>
                </el-form-item>
                <el-form-item label="Skype" prop="skype">
                    <el-input v-model="result.skype"/>
                </el-form-item>
                <el-form-item label="QQ" prop="qq">
                    <el-input v-model="result.qq"/>
                </el-form-item>
                <el-form-item label="Wechat" prop="wechat">
                    <el-input v-model="result.wechat"/>
                </el-form-item>
                <el-form-item label="Remark" prop="remark"  >
                    <el-input v-model="result.remark" type="textarea" :rows="5" />
                </el-form-item>
            </div>
            <div v-show="tab===2&&edit">
                <el-form-item label="Is Change Password">
                    <el-switch v-model="is_change_pwd"></el-switch>
                </el-form-item>
                <el-form-item label="New password">
                    <el-input v-model="new_password" type="password"/>
                </el-form-item>
                <el-form-item label="Confirm password">
                    <el-input v-model="confirm_password" type="password"/>
                </el-form-item>
            </div>
        </el-form>
        </div>
</mm-tab-title>

</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			result: {
                status: 'active',
                group_id: 1,
			},
            tab: 1,
            is_change_pwd:false,
            new_password:'',
            confirm_password:'',
            titles:[],
            is_show_auth,
            emailInputRO: true,
		};
	},
	methods: {
        rmRO() {
            this.emailInputRO = false;
        },
        setRO() {
            this.emailInputRO = true;
        },
		async submit() {
			await this.$validate(this.$refs.form);
            if(this.is_change_pwd == true){
                if(this.new_password != '' && this.new_password == this.confirm_password){
                    this.result.login_passwd = this.new_password;
                }
                else{
                    this.$message({
                        type:'error',
                        message:'Inconsistent password',
                    })
                    return;
                }
            }
            for(const group of this.$cache.group) {
                if(group.value == this.result.group_id) {
                    this.result.group_name = group.label;
                }
            }
            const request_path = this.edit?'/user/update':'/user/create';
            const result = await this.$post(request_path,this.result);
			if(this.edit){
				this.loadData();
			}else{
				this.$router.push({ path: "/userEdit",query:{id:result} });
			}
            
		},
		async loadData(){
			if (this.edit) {
				const id= this.$route.query['id'];
                const data = await this.$post('/user/list',{where:{user_id:id}});
                this.result = data.rows[0];
			}
        }
	},
    
	beforeMount() {
        this.loadData();
        if(this.edit){
            this.titles = ['Base Info','Change Password'];
        }
	}
};
</script>